(function ($, DGS) {
  window.DGS.OnLoad.getInstance().register(function () {
    var $thisSpot = $('.component.center-locator');

    /**
     * Restrict map height.
     */
    DGS.Event.getInstance().on('map:init', function (setHeight) {
      setHeight(500);

      // Prevent search window from scrolling
      $('#search-field', $thisSpot).on('focus', function (e) {
        e.stopImmediatePropagation();
      });
    });
  });
})(jQuery, window.DGS);